import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { RaceSelector, DataTable } from '@/components/shared';
import type { TshirtSizesManagerViewProps } from './tshirtsizesmanager.props';
import TshirtSizesFormDialog from './tshirtsizesmanager.form';

const TshirtSizesManagerView: React.FC<TshirtSizesManagerViewProps> = ({
  races, selectedRaceId, setSelectedRaceId, selectedRaceTypeId, setSelectedRaceTypeId,
  raceTypes, sizes, loading, sizeColumns, isDialogOpen, setIsDialogOpen,
  editingSize, setEditingSize, formData, setFormData, handleSubmit,
  deleteTarget, setDeleteTarget, confirmDelete, addDefaultSizes, embedded,
}) => {
  return (
    <>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Управување со големини на маички</CardTitle>
              <p className="text-sm text-muted-foreground mt-1">
                Додадете и управувајте со достапните големини на маички за секој настан
              </p>
            </div>
            <TshirtSizesFormDialog
              isDialogOpen={isDialogOpen}
              setIsDialogOpen={setIsDialogOpen}
              editingSize={editingSize}
              setEditingSize={setEditingSize}
              formData={formData}
              setFormData={setFormData}
              handleSubmit={handleSubmit}
              raceTypes={raceTypes}
              selectedRaceId={selectedRaceId}
              selectedRaceTypeId={selectedRaceTypeId}
              sizes={sizes}
              addDefaultSizes={addDefaultSizes}
              deleteTarget={deleteTarget}
              setDeleteTarget={setDeleteTarget}
              confirmDelete={confirmDelete}
            />
          </div>
        </CardHeader>
        <CardContent>
          {!embedded && (
            <div className="mb-4">
              <Label className="mb-1 block text-sm font-medium">Изберете настан</Label>
              <RaceSelector
                races={races}
                value={selectedRaceId}
                onChange={setSelectedRaceId}
                placeholder="-- Изберете настан --"
                showDate
              />
            </div>
          )}

          {selectedRaceId && raceTypes.length > 0 && (
            <div className="mb-4">
              <Label htmlFor="racetype-filter" className="mb-1 block text-sm font-medium">Филтрирај по тип на трка</Label>
              <select
                id="racetype-filter"
                value={selectedRaceTypeId}
                onChange={(e) => setSelectedRaceTypeId(e.target.value)}
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <option value="">-- Сите типови --</option>
                {raceTypes.map((rt: any) => (
                  <option key={rt.id} value={rt.id}>{rt.name}</option>
                ))}
              </select>
            </div>
          )}

          {!selectedRaceId && !embedded && (
            <p className="text-center text-muted-foreground py-8">Изберете настан за да ги видите големините на маички.</p>
          )}

          {selectedRaceId && (
            <DataTable
              columns={sizeColumns}
              data={sizes}
              loading={loading}
              emptyMessage='Нема додадени големини за овој настан. Кликнете „Додади стандардни" за брзо додавање.'
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default TshirtSizesManagerView;
